import React from "react";
import { useParams, Link } from "react-router-dom";
import articles from "../articles";
import logoWhite from "../assets/logo_white.png";
import "./ArticlePage.css";

export default function ArticlePage() {
  const { id } = useParams();
  const article = articles.find((a) => a.id === Number(id));

  if (!article) return <h2>Article not found.</h2>;

  return (
    <div className="article-page">
      <Link className="back-link" to="/">
        <span className="back-chevron">‹</span>
      </Link>

      <div className="article-hero">
        <div className="hero-left">
          <img src={logoWhite} alt="Synapse" className="magazine-logo" />
          <div className="hero-left-inner">
            <h1 className="article-title">{article.title}</h1>
            <p className="article-preview-text">{article.preview}</p>
          </div>
        </div>

        <div className="hero-right">
          {article.image && (
            <img src={article.image} alt={article.title} className="hero-image" />
          )}
        </div>
      </div>

      <div className="article-body">
        <p className="article-content">{article.content}</p>
      </div>
    </div>
  );
}
